var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1756 18.431V20H9.59688V18.287C9.59688 18.1913 9.59561 18.0956 9.59308 18H14.1845C14.1786 18.1434 14.1756 18.2871 14.1756 18.431ZM14.4602 16C14.679 15.0789 15.022 14.1895 15.4823 13.3584L16.3824 11.7334C18.2934 8.28326 15.8659 4 11.9994 4C8.24188 4 5.80468 8.06744 7.49958 11.5098L8.49062 13.5226C8.87878 14.311 9.16772 15.1435 9.35278 16H11.1556H13.104H14.4602ZM5.76064 12.412C3.41076 7.63929 6.78979 2 11.9994 2C17.36 2 20.7257 7.93851 18.0762 12.7219L17.1761 14.3469C16.4866 15.5917 16.1241 16.9991 16.1241 18.431V20.2039C16.1241 21.1958 15.3406 22 14.3742 22H9.52557C8.48888 22 7.64847 21.1373 7.64847 20.0732V18.287C7.64847 16.9453 7.34128 15.6223 6.75167 14.4248L5.76064 12.412Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.d53d183ce8018a9d4ac5903a45a2024b.svg";
export { ForwardRef as ReactComponent };